import Collapsible from "@/components/Collapsible";
import Breadcrumb from "@/components/Breadcrumb";
import Hero2 from "@/components/Hero2";
import SeoHead from "@/components/SeoHead";
import classes from "./styles.module.scss";
import { awards_helper } from "@/helpers/awards_helper";
import { Cookies } from "@/components";

export default function AwardsPage({all_awards}) {
  
  var awards = all_awards.reduce((acc, award) => {
    const year = new Date(award.date).getFullYear().toString();
    const existingYear = acc.find((entry) => entry.year === year);

    if (existingYear) {
      existingYear.items.push(award);
    } else {
      acc.push({ year, items: [award] });
    }

    return acc;
  }, []);

  awards = awards.sort((a, b) => parseInt(b.year) - parseInt(a.year));

  return (
    <>
      <div style={{marginTop: '120px'}} className={classes.cont}>
        <SeoHead
            page_name={`Awards | Xcede Group`}
            canonical_link={`https://www.xcedegroup.com/awards`}
          />
        <Breadcrumb label="Awards & Accreditations" />
        <Hero2 highlight="awards & accreditations" content="Don’t just take it from us. Our numerous award wins over the years illustrate our high level of service and commitment to our clients, candidates, and colleagues." readMore={false} split={false}/>
        <div style={{display: 'flex', flexDirection: 'column', gap: '40px', padding: '60px 0'}}>
          {awards.map( (award, index) => {
            return (
              <Collapsible key={index} title={award.year} index={index} awards={award.items}/>
            )
          })}
        </div>
      </div>
      
    </>
  );
}

export async function getStaticProps({}) {
  const all_awards = awards_helper.fetch();

  return {
    props: {
      all_awards
    },
  };
}